import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2'; // Import SweetAlert
import RequestServies from '../../../services/RequestServies';

const RequisitionNumberModal = ({ show, handleClose, store, onSuccess }) => {
  const initialFormValues = {
    requisitionNo: 0,
    store: '',
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');

  // Handle input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  // Handle file input changes for image preview
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  // Validate form fields and display Swal alerts
  const validateForm = () => {
    if (!formValues.requisitionNo || formValues.requisitionNo <= 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Requisition No',
        text: 'Please enter a valid requisition number.',
      });
      return false;
    }

    if (!formValues.store) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Store',
        text: 'Please select a store from the list.',
      });
      return false;
    }

    if (!formValues.image) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Image',
        text: 'Please upload an image.',
      });
      return false;
    }

    return true;
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate the form before submitting
    if (!validateForm()) {
      return;
    }

    try {
      const formData = new FormData();
      for (const key in formValues) {
        if (key !== 'image' || formValues[key] instanceof File) {
          formData.append(key, formValues[key]);
        }
      }

      // Submit the form data to the service
      await RequestServies.createRequest(formData);

      // Show success message using Swal
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Requisition form added successfully!',
      });

      onSuccess(); // Call onSuccess prop
      handleClose(); // Close the modal after successful submission
    } catch (error) {
      // Show error message using Swal
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Failed to add requisition form!',
      });
    }
  };

  // Reset form values when the modal is closed
  useEffect(() => {
    if (!show) {
      setFormValues(initialFormValues); // Reset form to initial state
      setPreviewImage('img/placeholder-img.png'); // Reset image preview
    }
  }, [show]); // Trigger when the modal visibility changes

  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>
            <i className="fas fa-edit"></i> Requisition Form
          </Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6">
                <label>Requisition No</label>
                <input
                  type="number"
                  name="requisitionNo"
                  className="form-control form-control-sm"
                  value={formValues.requisitionNo}
                  onChange={handleInputChange}
                  placeholder=""
                />
              </Col>
              <Col md="6">
                <label>Store</label>
                <select
                  name="store"
                  className="form-control form-control-sm"
                  value={formValues.store}
                  onChange={handleInputChange}
                >
                  <option value="">Select a Store</option>
                  {store.map((s) => (
                    <option key={s._id} value={s._id}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Upload Image</label>
                <input
                  type="file"
                  name="photo"
                  className="form-control form-control-sm"
                  onChange={handleFileChange}
                />
                
                <div className="file-preview text-center">
                  <img
                    id="uploadFile"
                    src={previewImage}
                    alt="Preview"
                    className="img-fluid"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Save changes
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default RequisitionNumberModal;
